// Order Product Management Types
// Request types for adding products (bulk addition)

export interface IProductToAdd {
    product_id: number;
    count?: number;
    unit_partition_id?: number;
    available_weight?: number;
}

export interface IAddOrderProductRequest {
    storeId: number;
    products: IProductToAdd[];
}

export interface IUpdateOrderProductRequest {
    productOrderId: number;
    count?: number;
    unitPartitionId?: number;
    availableWeight?: number;
    isAccepted?: boolean;
}

export interface IRemoveOrderProductRequest {
    productOrderId: number;
}

export interface IOrderProductBatchAllocationRequest {
    productOrderId: number;
    batchId: number;
    quantity: number;
}

export interface IOrderProductBatchWithdrawal {
    batchId: number;
    quantity: number;
    batchNumber?: string | null;
    expirationDate?: string | null;
    enteredQuantityByUnit?: number;
    withdrawnQuantityByUnit?: number;
    availableQuantityByUnit?: number;
    availableQuantity?: number;
}

// Response types
export interface IOrderProductResponse {
    success: boolean;
    message: string;
    data?: IProductOrder;
}

export interface IOrderProductBulkResponse {
    success: boolean;
    message: string;
    data: IProductOrder[];
}

export interface IProductOrder {
    id: number;
    order_id: number;
    product_id: number;
    store_id: number;
    count: number;
    reserved_count: number;
    unit_partition_id: number;
    unit_partition_percentage: number;
    price: number;
    price_on_client: number;
    is_available: boolean;
    is_accepted: boolean;
    product: {
        id: number;
        name: string;
        description?: string;
    };
    store: {
        id: number;
        name: string;
    };
    unitPartition?: {
        id: number;
        name: string;
        percentage: number;
    };
    batchWithdrawals?: IOrderProductBatchWithdrawal[] | null;
}

// Query input method enum
export enum QuantityInputMethod {
    BY_COUNT = "count",
    BY_WEIGHT = "weight",
}
